module.exports = __webpack_public_path__ + "static/img/default.1be95e91.png";